import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as Dictionary from 'Models/Dictionary';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as AlertModule from 'Modules/AlertModule';
import * as NotificationModule from 'Modules/NotificationModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as MapModule from 'Modules/MapModule';
import * as HistoryModule from 'Modules/HistoryModule';
import { createSerachQuery } from 'Connectors/_main';
import { Cell } from 'HelperFunctions/Lists';
import { RootState } from 'Redux/Reducers/_RootReducer';
import i18next from 'i18next';
import {IconButton} from "@material-ui/core";

type Props = {
    // history: any;
};

type State = {
    subMenuVisible: boolean;
};

type DispatchedP = {
    notificationStore: NotificationModule.Types.NotificationStore;
    userStore: UserModule.Types.UserStore;
    t?: i18next.TFunction;
};
type ConnectedP = {
    getNotifications: (params?: URLSearchParams) => void;
    readNotification: (notificationId: number) => void;
    openSSENotification: (token:string) => void;
    updateParams: () => void;
    setActivePage: (page: ViewManagementModule.Types.Page) => void;
    setActiveCarDetailsView: (zone: HistoryModule.EnumTypes.CarDetailsViewType) => void;
    getSingleCarDetails: (carId: number) => void;
    setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => void;
    setMapCenter: (center: MapModule.Types.MapCenter) => void;
    setMapZoom: (zoom: number) => void;
    setActiveNotification: (notification: NotificationModule.Types.NotificationDto) => void;
    showZones: () => void;
    clearNotifications: () => void;
};
class Notifications extends React.Component<Props & DispatchedP & ConnectedP, State> {
    private node;
    constructor(props: Props & DispatchedP & ConnectedP) {
        super(props);
        this.state = {
            subMenuVisible: false
        };
        this.readNotification = this.readNotification.bind(this);
        this.onNotifiationClick = this.onNotifiationClick.bind(this);
    }

    public async componentDidMount() {
        const params = createSerachQuery(this.props.notificationStore.notificationsParams);
        await this.props.getNotifications(params);
        await this.props.openSSENotification(this.props.userStore.token);
        document.addEventListener('click', this.handleClick, false);
    }

    private async readNotification(notificationId: number) {
        await this.props.readNotification(notificationId);
    }

    private async loadMore() {
        await this.props.updateParams();
        const params = createSerachQuery(this.props.notificationStore.notificationsParams);
        await this.props.getNotifications(params);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    private async onNotifiationClick(notification: NotificationModule.Types.NotificationDto) {
        this.props.setActivePage(Dictionary.PageDetails.get(ViewManagementModule.EnumTypes.Page.MAP));
        await this.props.getSingleCarDetails(notification.dataframe.carId);
        this.props.setActiveNotification(notification);
        this.props.setActiveCarDetailsView(HistoryModule.EnumTypes.CarDetailsViewType.CAR_DETAILS);
        this.props.setMapZoom(16);
        this.props.setMapCenter({ lat: notification.dataframe.latitude, lng: notification.dataframe.longitude });
        if (notification.alertCondition === AlertModule.EnumTypes.AlertCondition.ENTERING_AREA || notification.alertCondition === AlertModule.EnumTypes.AlertCondition.LEAVING_AREA) {
            this.props.showZones();
        }
    }
    private handleClick = e => {
        if (this.node && this.node.contains(e.target)) {
            return;
        }
        this.setState({
            subMenuVisible: false
        });
    };

    private clearAllNotifications = () => {
      this.props.clearNotifications()
    }

    public render() {
        const { subMenuVisible } = this.state;
        const { t, notificationStore } = this.props;
        return (
            <div className="header__account header__notifications" ref={node => (this.node = node)}>
                <div className="header__notifications--img_wrapper" onClick={() => this.setState({ subMenuVisible: !this.state.subMenuVisible })}>
                    <img width="17" className="header__account-img" src={'/images/icons/alert-bell.svg'} />
                    {notificationStore.notifications && notificationStore.notifications.unreadNotifications > 0 && (
                        <div className="header__notifications_count">{notificationStore.notifications.unreadNotifications}</div>
                    )}
                </div>
                {subMenuVisible && notificationStore.notifications && (
                    <div className="header__account--submenu header__notification--submenu">
                        <ul className="header--list">
                            <li className="header__account--submenu_element">
                                {/* ToDo: do refaktoru, gorzej się chyba nie dało napisać.
                                 Element liniowy przedupcony do flexa i ciul ze semantyką.*/}
                                <span className="header__account--submenu_element-inner header__alerts">
                                  {t('ALERTS')}
                                  <IconButton className="header__clear-notifications" onClick={this.clearAllNotifications} disableRipple>
                                  <img
                                    src="/images/icons/check-notifications.svg"
                                    alt="Oznacz wszystkie powiadomienia jako przeczytane"
                                  />
                                </IconButton>
                                </span>
                            </li>
                          <li>
                            <ul className="header--list__inner">
                                    {notificationStore.notifications.paginatedList.results.map((element, idx) => {
                                        return (
                                            <li key={idx}>
                                                <NotificationBlock t={t} onClick={this.onNotifiationClick} notification={element} onReadAction={this.readNotification} />
                                            </li>
                                        );
                                    })}
                                </ul>
                            </li>
                            {notificationStore.notifications.paginatedList.results.length > 0 &&
                                notificationStore.notifications.paginatedList.totalCount !== notificationStore.notifications.paginatedList.results.length && (
                                    <div className="header__load-more" onClick={() => this.loadMore()}>
                                        <div className="btn btn--clean">{t('loadMore')}</div>
                                    </div>
                                )}
                            {notificationStore.notifications.paginatedList.results.length === 0 && (
                                <li className="header__account--submenu_element">
                                    <span className="header__account--submenu_element-inner">{t('noNotificationData')}</span>
                                </li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: RootState): DispatchedP {
    return {
        notificationStore: state.notificationStore,
        userStore: state.userStore
    };
}

function mapDispachToProps(dispatch: any): ConnectedP {
    return {
        getNotifications: (params?: URLSearchParams) => dispatch(NotificationModule.Actions.getNotifications(params)),
        readNotification: (notificationId: number) => dispatch(NotificationModule.Actions.readNotification(notificationId)),
        clearNotifications: () => dispatch(NotificationModule.Actions.clearNotifications()),
        setActiveNotification: (notification: NotificationModule.Types.NotificationDto) => dispatch(NotificationModule.Actions.setActiveNotification(notification)),
        updateParams: () => dispatch(NotificationModule.Actions.updateParams()),
        openSSENotification: (token:string) => dispatch(NotificationModule.Actions.openSSENotification(token)),
        setActivePage: (page: ViewManagementModule.Types.Page) => dispatch(ViewManagementModule.Actions.setActivePage(page, true)),
        setActiveCarDetailsView: (zone: HistoryModule.EnumTypes.CarDetailsViewType) => dispatch(ViewManagementModule.Actions.setActiveCarDetailsView(zone)),
        getSingleCarDetails: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId)),
        setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => dispatch(ViewManagementModule.Actions.SetActiveRideViewType(activeRideViewType)),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center)),
        setMapZoom: (zoom: number) => dispatch(MapModule.Actions.setMapZoom(zoom)),
        showZones: () => dispatch(ViewManagementModule.Actions.showZones())
    };
}

export default withTranslation ('mainMenu')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(Notifications) as React.ComponentType<any>
);

export const NotificationBlock = (props: {
    notification: NotificationModule.Types.NotificationDto;
    onReadAction: (notificationId: number) => void;
    t: i18next.TFunction;
    onClick?: (not: NotificationModule.Types.NotificationDto) => void;
}) => (
    <div
        className={`notificationBlock ${props.notification.read ? '' : 'notificationBlock--unread'}`}
        onMouseEnter={() => {
            if (props.notification.read === false) {
                props.onReadAction(props.notification.id);
            }
        }}
        onClick={() => props.onClick(props.notification)}
    >
        <div className="notificationBlock__carIcon">
            <img src={Dictionary.PassengerCarSpeedIcons.get(VehiclesModule.EnumTypes.VehicleSpeedEnum.GREY)} alt="" />
        </div>
        <div className="notificationBlock__content">
            <div className="notificationBlock__heading">
                <h4 className="notificationBlock__title bold">
                    {props.notification.alertCondition ? Dictionary.AlertConditionDictionaryMap.get(props.notification.alertCondition) : props.notification.title}
                </h4>
                <span className="notificationBlock__date">{Cell.Date({ value: props.notification.creationDate })}</span>
            </div>
            <div className="notificationBlock__details">
                <p className="notificationBlock__vin"> {props.notification.alertCondition ? props.notification.title : props.notification.message}</p>
                {props.notification.alertCondition === AlertModule.EnumTypes.AlertCondition.SPEEDING && (
                    <p className="notificationBlock__speed">
                        {props.t('carDetails:speedGps')}:{' '}
                        <span className={`bold ${props.notification.dataframe.speedLimitExceedance?.toLowerCase() ?? ''}`}>{props.notification.dataframe.speedGps} km/h</span>
                    </p>
                )}
                {props.notification.alertCondition === AlertModule.EnumTypes.AlertCondition.ENTERING_AREA && props.notification.alertHistoryLog && (
                    <p className="notificationBlock__speed">
                        {props.t('carDetails:domain')}: <span className="bold">{props.notification.alertHistoryLog.domainTitle}</span>
                    </p>
                )}
                {props.notification.event && (
                    <p className="notificationBlock__speed">
                        {props.t('carDetails:event')}: <span className="bold">{props.t(`dictionary:${props.notification.event}`)}</span>
                    </p>
                )}
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Composites/Notifications.tsx